import React, { useState, useEffect } from 'react';
import { API } from '../../../API/API';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../../components/PageHeader/PageHeader';
import ColEdit from '../../../components/ColEdit/ColEdit';

const HiredReport = (props) => {

    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);
    const [columns] = useState([{
        name: 'Ажилтны нэр',
        fieldName: 'firstname',
        minColSize: 'mid',
        onRender: (item) => {
            return (
                <ColEdit onClick={() => onPressEmp(item.empid)}>{item.firstname}</ColEdit>
            );
        }
    },
    {
        name: 'Ажлын байр/Албан тушаал',
        fieldName: 'positionname'
    },
    {
        name: 'Ажил эрхлэлтийн төрөл ',
        fieldName: 'employmenttypename'
    },
    {
        name: 'Хуулийн этгээд',
        fieldName: 'companyname'
    },
    {
        name: 'Дотоод нэгж',
        fieldName: 'departmentname'
    },
    {
        name: 'Эхэлсэн',
        fieldName: 'begindate'
    },
    {
        name: 'Дууссан',
        fieldName: 'enddate'
    },
    {
        name: 'Хөдөлмөрийн нөхцөл',
        fieldName: 'labourconditionname'
    },
    {
        name: 'Даатгуулагчийн төрөл',
        fieldName: 'insuretypename'
    },
    {
        name: 'Хүйс',
        fieldName: 'empgendername'
    }]);
    const [loading, setLoading] = useState(false);

    const getData = async () => {
        setLoading(true);
        let tData = [];
        await API.get('/api/humanresource/report/get_emp_hired_report').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                tData = response.data.retdata;
            }
        });
        setData(tData);
        setOData(tData);
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, []);

    const onPressEmp = (p_empid) => {
        if (p_empid) {
            navigate('/hrsuite/employee/' + p_empid);
        }
    }

    const onSearch = (p_data) => {
        setData(p_data);
    }

    return (
        <div>
            <PageHeader
                title='Ажилд орсон'
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                dataCount={data?.length}
                loading={loading}
            />
            <GridDefaultShimmer
                data={data}
                columns={columns}
                loading={loading}
            />
        </div>
    );
}

export default HiredReport;